import React, { useCallback, useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { CardFilters } from '@/features/crm/types';
import { useStepColumns } from '@/features/crm/api/listColumns';
import { TypesCRM } from '@/types/crm';
import DragAndDropColumns from '@/components/Base/DragAndDrop';

interface CrmColumnsContainerProps {
  type: TypesCRM;
  filters: CardFilters;
  setOpenModal: (open: boolean) => void;
  onTotalVagasChange?: (total: number) => void;
}

export const CrmColumnsContainer: React.FC<CrmColumnsContainerProps> = ({
  type,
  filters,
  setOpenModal,
  onTotalVagasChange
}) => {
  const [observerElement, setObserverElement] = useState<HTMLDivElement | null>(null);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading
  } = useStepColumns(type);

  // Flatten all pages into a single array
  const allColumns = data?.pages.flatMap(page => page.results) ?? [];

  const totalVagasLivre = data?.pages[0]?.total_vagas_livre ?? 0;

  console.log('CrmColumnsContainer - totalVagasLivre:', totalVagasLivre, 'data:', data);

  useEffect(() => {
    if (onTotalVagasChange && !isLoading) {
      console.log('Updating parent with totalVagas:', totalVagasLivre);
      onTotalVagasChange(totalVagasLivre);
    }
  }, [totalVagasLivre, onTotalVagasChange, isLoading]);

  // Ref callback for infinite scroll
  const lastColumnRef = useCallback(
    (node: HTMLDivElement) => {
      if (isLoading || isFetchingNextPage) return;

      if (observerElement) {
        // Disconnect previous observer
      }

      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });

      if (node) {
        observer.observe(node);
        setObserverElement(node);
      }
    },
    [isLoading, isFetchingNextPage, hasNextPage, fetchNextPage, observerElement]
  );

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <DragAndDropColumns
        columns={allColumns}
        setOpenModal={setOpenModal}
        filterName={filters.nome || ''}
        type={type}
        filters={filters}
      />

      {/* Scroll trigger for infinite loading */}
      <div ref={lastColumnRef} style={{ height: '20px', width: '100%' }} />

      {isFetchingNextPage && (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
};
